/*
 * NotFound — SPA-side 404 page.
 *
 * Rendered when (a) React Router's catch-all matches an unknown route, or
 * (b) BlogPost can't find a slug after the live API loads. Always emits a
 * `noindex` robots meta so crawlers drop the URL even though the HTTP
 * response is 200 (the SPA index.html was already served). For routes that
 * were never pre-rendered, CloudFront returns a real HTTP 404 before this
 * component ever loads — this is the belt-and-suspenders client-side guard.
 */

import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <MKBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        textAlign="center"
        px={3}
      >
        <MKTypography variant="h1" color="dark" mb={2}>
          404
        </MKTypography>
        <MKTypography variant="h4" color="text" mb={3}>
          Page not found
        </MKTypography>
        <MKTypography variant="body2" color="text" mb={4}>
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </MKTypography>
        <MKButton component={Link} to="/" variant="contained" color="info">
          Go to homepage
        </MKButton>
      </MKBox>
    </>
  );
}
